import { useState, useEffect } from 'react'
export function useWindowSize() {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight })
  useEffect(() => {
    function handle() { setSize({ width: window.innerWidth, height: window.innerHeight }) }
    window.addEventListener('resize', handle)
    return () => window.removeEventListener('resize', handle)
  }, [])
  return size
}
export const isMobile = (width) => width < 768
export const isTablet = (width) => width >= 768 && width < 1024
